import Audittransactions from "@/views/modules/audit-transactions/Audittransactions.vue";
import Audit from "@/views/modules/audit-transactions/Audit.vue";
import Auditstate from "@/views/modules/audit-transactions/Audit-states/Audit-states.vue";
import AuditRecargas from "@/views/modules/audit-transactions/Audit-Recargas/Audit-Recargas.vue";
import CardBalanceReport from "@/views/modules/Audit-card/CardBalanceReport1.vue";
import layouts from "../../layout";
export default {
  path: "/Audit-transactions",
  name: "audit-transaction",
  component: Audittransactions,
  meta: {
    auth: true
  },
  redirect: {
    name: "Audit"
  },
  children: [
    {
      path: "Audit",
      name: "Audit",
      component: Audit,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Auditoria",
        tags: ["Auditoria"],
        index: true
      }
    },
    {
      path: "Audit-state",
      name: "Audit-state",
      component: Auditstate,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Auditoria",
        tags: ["Auditoria Estados"],
        index: true
      }
    },

    {
      path: "Audit-Recargas",
      name: "Audit-Recargas",
      component: AuditRecargas,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Auditoria",
        tags: ["Auditoria Recargas"],
        index: true
      }
    },
    {
      path: "Audit-Card",
      name: "Audit-Card",
      component: CardBalanceReport,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Auditoria",
        tags: ["Auditoria de Tarjetas"],
        index: true
      }
    }
  ]
};
